import { INK, NODE_FILL, SPINE_W } from '../timelineDiagramGeometry'

// A small hollow node ring marking a junction on the spine. Its fill tracks the
// live page backdrop (NODE_FILL → --playbook-epilogue-bg) and transitions so it
// fades in step with the page as the epilogue dims.
export const NodeDot = ({ cx, cy, r = 4 }: { cx: number; cy: number; r?: number }) => (
  <circle
    cx={cx}
    cy={cy}
    r={r}
    fill={NODE_FILL}
    stroke={INK}
    strokeWidth={SPINE_W}
    // Fade the fill over the same period AND easing as the page background
    // overlays (Tailwind's transition-opacity default; see Playbook).
    style={{ transition: 'fill var(--playbook-epilogue-bg-fade-ms, 333ms) cubic-bezier(0.4, 0, 0.2, 1)' }}
  />
)
